
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {Lambda as LambdaService} from "@/simulation/Lambda";

    @Component
    export default class Lambda extends Vue {
        @Prop() private lambda!: LambdaService;
    }
